import { takeEvery, call, put } from 'redux-saga/effects';
import { getEmailJobs, sendEmail } from '../apis';
import { getRequest, postRequest } from '../../network';
import {
  sendEmailStart,
  sendEmailSuccess,
  sendEmailFail,
  fetchJobsStart,
  fetchJobsSuccess,
  fetchJobsFail
} from '../slices/emailSlice';

function* sendEmailSaga(action) {
  const { payload, callback } = action.payload || {};
  try {
    const response = yield call(postRequest, sendEmail, payload);
    yield put(sendEmailSuccess(response));
    if (callback && typeof callback === 'function') {
      yield call(callback, true, response);
    }
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      'Something went wrong';
    yield put(sendEmailFail(message));
    if (callback && typeof callback === 'function') {
      yield call(callback, false, message);
    }
  }
}

function* fetchJobsSaga(action) {
  try {
    const response = yield call(getRequest, getEmailJobs, action.payload || {});
    yield put(fetchJobsSuccess(response));
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      'Something went wrong';
    yield put(fetchJobsFail(message));
  }
}

export function* watchEmail() {
  yield takeEvery(sendEmailStart.type, sendEmailSaga);
  yield takeEvery(fetchJobsStart.type, fetchJobsSaga);
}

